import { parseApiDateTime } from './parseApiDateTime'
import { DEFAULT_API_DATE_TIME_FORMAT } from './apiDateTimeFormats.constants'

export const formatApiDateTimeInZone = (
  value: string | null | undefined,
  zone: string,
  format = DEFAULT_API_DATE_TIME_FORMAT
) => {
  const dateTime = parseApiDateTime(value)
  if (!dateTime) return 'N/A'
  return dateTime.setZone(zone).toFormat(format)
}
